import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { instance } from "@/lib/axios/instance";

interface SyncCockpitPublicationVariables {
  clientId: string;
  publicationId: string;
}

interface ProblemDetails {
  detail?: string;
  title?: string;
  status?: number;
}

export function useSyncCockpitPublicationMutation() {
  return useMutation<void, AxiosError<ProblemDetails>, SyncCockpitPublicationVariables>({
    mutationFn: async ({ clientId, publicationId }) => {
      const encodedPublicationId = encodeURIComponent(publicationId);
      await instance.post(
        `/api/v2/Integrations/cockpit/job-source/Publications/${encodedPublicationId}/Sync`,
        { clientId }
      );
    },
  });
}
